export const UX_EVENT = 'UX/EVENT'

export const uxEvent = event => ({
  type: UX_EVENT,
  payload: { event },
})
